"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToggle = void 0;
const react_1 = require("react");
const useToggle = (initialIsOpen = false) => {
    const [isOpen, setOpen] = (0, react_1.useState)(initialIsOpen);
    const open = (0, react_1.useCallback)(() => setOpen(true), []);
    const close = (0, react_1.useCallback)(() => setOpen(false), []);
    const toggle = (0, react_1.useCallback)(() => setOpen((isOpen) => !isOpen), []);
    return {
        close,
        isOpen,
        open,
        toggle,
    };
};
exports.useToggle = useToggle;
//# sourceMappingURL=index.js.map